import React from 'react';
import { ResolutionCondition } from 'brandi';

export const ConditionsContext = React.createContext<ResolutionCondition[]>([]);
